module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/main-visual-text-f7a8469c07a5df29c29158fc016ebe0b.png";